"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var owa_options_core_1 = require("owa-options-core");
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
var owa_session_store_1 = require("owa-session-store");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(legacy_1.action('saveSignatureOption')(function saveSignatureOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions, serviceOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    serviceOptions = {};
                    if (optionState.editorViewState.isDirty) {
                        userOptions.SignatureHtml = optionState.editorViewState.content;
                        serviceOptions.SignatureHtml = optionState.editorViewState.content;
                        // Reset isDirty so the save/discard buttons reset
                        optionState.editorViewState.isDirty = false;
                    }
                    if (optionState.signNewMails !== null) {
                        userOptions.AutoAddSignature = optionState.signNewMails;
                        serviceOptions.AutoAddSignature = optionState.signNewMails;
                    }
                    if (optionState.signReplies !== null) {
                        userOptions.AutoAddSignatureOnReply = optionState.signReplies;
                        serviceOptions.AutoAddSignatureOnReply = optionState.signReplies;
                    }
                    return [4 /*yield*/, owa_options_core_1.setMailboxMessageConfiguration(serviceOptions)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveSignatureOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-signature-option/lib/actions/saveSignatureOption.js
// module id = 5013
// module chunks = 2